/* eslint-disable no-console */
import { FC, ReactElement, useCallback } from 'react'

import ExploreCarousel from '../../components/carousel/exploreCarousel'
import MainCarousel from '../../components/carousel/mainCarousel'
import ProductCarousel from '../../components/carousel/productCarousel'
import TestimonialsCarousel from '../../components/carousel/testimonialsCarousel'
import CategoryTetris from '../../components/categoryTetris'
import Page from '../../components/page'
import VendorList from '../../components/vendors'
import { useI18n } from '../../hooks'
import { useAppSelector } from '../../store'
import { PromotionalKeys } from '../../types'
import { filterByPromoCategory } from '../../utils'

import './homepage.css'
const Homepage: FC = (): ReactElement => {
  const { products } = useAppSelector((state) => state.productReducer)
  const { promoCategories } = useAppSelector((state) => state.categoryReducer)

  const getProductsByPromoCategory = useCallback(
    (promoKey: PromotionalKeys) => {
      return filterByPromoCategory([...products], promoCategories, promoKey)
    },
    [products, promoCategories]
  )

  const { t } = useI18n()
  return (
    <Page
      metaData={{ title: t('Homepage_meta_title'), description: t('Homepage_meta_description'), charset: 'utf-8' }}
      className="homepage"
    >
      <header>
        <MainCarousel />
      </header>
      <section className="section product-carousel-section" id="product-slider">
        <ProductCarousel
          products={getProductsByPromoCategory('trending')}
          title={t('Categories_trendingProducts')}
          skipToId="#homepage-category-tetris"
          viewAllUrl="/shop?category=trending"
        />
      </section>
      <section className="section categories-section" id="homepage-category-tetris">
        <CategoryTetris />
      </section>
      <section className="section product-carousel-section" id="top-deals-slider">
        <ProductCarousel
          products={getProductsByPromoCategory('topDeals')}
          title={t('Categories_topDeals')}
          skipToId="#explore-slider"
          viewAllUrl="/shop?category=top deals"
        />
      </section>
      <section className="section explore-carousel-section" id="explore-slider">
        <ExploreCarousel />
      </section>
      <section className="section testimonials-carousel-section">
        <TestimonialsCarousel />
      </section>
      <section className="section vendors-section">
        <VendorList />
      </section>
    </Page>
  )
}

export default Homepage
